import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { LeadCard } from './LeadCard';

// Colores de borde superior para columnas
const COLUMN_COLORS = {
  'new': 'border-t-indigo-500',
  'contacted': 'border-t-blue-500',
  'meeting': 'border-t-sky-500',
  'proposal': 'border-t-cyan-500',
  'negotiation': 'border-t-violet-500',
  'won': 'border-t-emerald-500 bg-emerald-50/30', // Fondo sutil verde para Ganado
  'lost': 'border-t-slate-300 bg-slate-50' // Fondo sutil gris para Perdido
};

export const KanbanColumn = ({ id, title, leads, isMobile, onMoveToStage, onCardClick, onDelete }) => {
  const { setNodeRef } = useDroppable({ id });

  // Estilos específicos por tipo de columna
  const containerClass = COLUMN_COLORS[id] || 'border-t-indigo-500';
  const isWon = id === 'won';
  const isLost = id === 'lost';

  return (
    <div className={`
      flex-shrink-0 flex flex-col h-full rounded-lg
      ${isMobile ? 'w-[85vw] snap-center mr-4' : 'w-[280px]'}
      bg-slate-50/50 
    `}>
      {/* Header de Columna */}
      <div className={`
        p-3 border-t-4 rounded-t-lg bg-slate-100 flex justify-between items-center
        ${containerClass}
      `}>
        <h3 className={`
          text-xs font-bold uppercase tracking-wider
          ${isWon ? 'text-emerald-700' : isLost ? 'text-slate-500' : 'text-slate-600'}
        `}>
          {title}
        </h3>
        <span className="bg-white text-slate-600 text-[10px] font-bold px-2 py-0.5 rounded-full shadow-sm border border-slate-200">
          {leads.length}
        </span>
      </div>

      {/* Área de Drop */}
      <div 
        ref={setNodeRef} 
        className={`
          flex-1 p-2 overflow-y-auto min-h-[150px]
          ${isWon ? 'bg-emerald-50/10' : ''}
        `}
      >
        <SortableContext 
          id={id} 
          items={leads.map(l => l.id)} 
          strategy={verticalListSortingStrategy}
        >
          {leads.map((lead) => (
            <LeadCard 
              key={lead.id} 
              lead={lead} 
              isMobile={isMobile}
              onMoveToStage={onMoveToStage}
              onClick={onCardClick}
              onDelete={onDelete}
            />
          ))}
          
          {/* Placeholder visual cuando está vacío */}
          {leads.length === 0 && (
            <div className="h-24 border-2 border-dashed border-slate-200 rounded-lg flex items-center justify-center text-slate-400 text-xs italic">
              Arrastra leads aquí
            </div>
          )}
        </SortableContext>
      </div>
    </div>
  );
};
